import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import "./styles.scss";
import "./mobile.scss";
import { FeaturesNews, ForeignNews, MainNews, SportsNews } from "./templates";
import { useLocation, withRouter } from "react-router-dom";
import {
  HomePageCenterAdd,
  HomeRightCenterAdd,
  HomeRightTopAdd,
} from "../templates/advertiesments";
import TrendingNews from "../templates/trendingNews/index";
import TopNews from "../templates/topNews";
import CategoryMainNews from "./templates/categoryMainNews";
import SuggestionsNews from "../templates/suggestionsNews";
import CategorySubNews from "./templates/categorySubNews";
import OffersPreview from "../templates/offersPreviewing";
import OffersPreviewRight from "../templates/offersPreviewingRight";
import WidgetNewsCard from "../templates/widgetNewsCard";

const hotNewsId = process.env.REACT_APP_HOT_NEWS;
const sportNewsId = process.env.REACT_APP_SPORT_NEWS;
const foreignNewsId = process.env.REACT_APP_FOREIGN_NEWS;
const otherNewsId = process.env.REACT_APP_ENTERTAINMENT_NEWS;

const Index = ({ onChangeCategory, onChangeTag, onchangeBGImage }) => {
  const [isSticky, setIsSticky] = useState(false);
  const [isBottom, setIsBottom] = useState(false);
  const [isSecond, setIsSecond] = useState(false);
  const [isTrending, setIsTrending] = useState(false);
  const [isOther, setIsOther] = useState(false);
  const [isLast, setIsLast] = useState(false);
  const onChangeMenu = (category) => {
    onChangeCategory(category);
  };

  const handleChangeTag = (tag) => {
    onChangeTag(tag);
  };

  const handleChangeImage = (image) => {
    if (image) {
      onchangeBGImage(image);
    }
  };

  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY >= 1235);
      setIsSecond(window.scrollY >= 100);
      setIsTrending(window.scrollY >= 1005);
      setIsOther(window.scrollY >= 3490);
      setIsBottom(window.scrollY >= 5600);
      setIsLast(window.scrollY >= 6900);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <Helmet>
        <title> Sri Lanka News Today – Hope of a New Era</title>
        <meta
          name="description"
          content="Get the latest news, insights, and stories from Sri Lanka and beyond. Hope of a New Era delivers real-time updates and thoughtful commentary."
        />
        <meta
          name="keywords"
          content="Sri Lanka news, latest news, Sinhala news, English news, news, political news, global news, breaking news, politics, economy, culture"
        />
        <meta name="author" content="Hope of a New Era" />
        <meta
          property="og:title"
          content="Sri Lanka News, Insights & Stories - News first in Sri Lanka"
        />
        <meta
          property="og:description"
          content="Real-time news and analysis from Sri Lanka. Trusted updates and in-depth coverage."
        />
        <meta property="og:image" content="%PUBLIC_URL%/logo192.png" />
        <meta property="og:url" content="https://hopeofanewera.org/" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Hope of a New Era – Sri Lanka News first"
        />
        <link rel="canonical" href="https://hopeofanewera.org/" />
      </Helmet>
      <div className={`home-wrapper`}>
        {/* <div className={"parent"}> */}
        {/* <div className={"black_"}> */}
        <div className={`hw__special-news-group group-1`}>
          <div className={"side-left"}>
            <FeaturesNews
              setMenuName={onChangeMenu}
              setTagData={handleChangeTag}
            />
          </div>
          <div
            className={` ${isSticky ? "sticky-sidebar" : ""}`}
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            {/* <BusinessNews
              setMenuName={onChangeMenu}
              setTagData={handleChangeTag}
            /> */}
            <HomeRightCenterAdd />
          </div>
        </div>
        {/* </div> */}
        <div className={"hw__special-news-group group-2"}>
          {/* <LiveFeed /> */}
          <MainNews
            setMenuName={onChangeMenu}
            setTagData={handleChangeTag}
            setNewsImage={handleChangeImage}
          />
          {/* <div className={"hwsng__advertiesment"}>Advertisement with us </div> */}
          <HomePageCenterAdd />
          {/*<Election2025 setMenuName={onChangeMenu}
            setTagData={handleChangeTag} />*/}
          <CategoryMainNews
            setMenuName={onChangeMenu}
            setTagData={handleChangeTag}
            categoryId={hotNewsId}
            active={isSecond}
          />
          <div className="mt-2 mb-2">
            <OffersPreview count={4} active={isTrending} />
          </div>
          <WidgetNewsCard />
          <TrendingNews active={isTrending} />
          <CategoryMainNews
            setMenuName={onChangeMenu}
            setTagData={handleChangeTag}
            categoryId={foreignNewsId}
            active={isTrending}
          />
          <TopNews active={isTrending} />
          {/* <WidgetNewsCard /> */}
          <CategoryMainNews
            setMenuName={onChangeMenu}
            setTagData={handleChangeTag}
            categoryId={otherNewsId}
            active={isTrending}
          />
          <CategoryMainNews
            setMenuName={onChangeMenu}
            setTagData={handleChangeTag}
            categoryId={sportNewsId}
            active={isTrending}
          />
          <div className="home_all-news">
            {/* <HotNews setMenuName={onChangeMenu} setTagData={handleChangeTag} /> */}
            <CategorySubNews active={isOther} /> {/*all News */}
          </div>
        </div>

        {/* <div className={"black_"}> */}
        <div className={`hw__special-news-group group-3`}>
          {/* <div className={"home__advertiesment"}>Advertisement with us </div> */}
          <div className={"side-left"}>
            {/* <ForeignNews
              setMenuName={onChangeMenu}
              setTagData={handleChangeTag}
            /> */}

            <HomeRightTopAdd />
          </div>
          {/* {!isSticky && (
            <SportsNews
              setMenuName={onChangeMenu}
              setTagData={handleChangeTag}
              active={isSecond}
            />
          )} */}
          <div
            className={` ${
              isSticky ? "sticky-sidebar" : "animate__animated animate__fadeIn"
            }`}
          >
            <SuggestionsNews news_id={"1"} no_of_news={"1"} type={"small"} />

            {/* <div className={"home__advertiesment"}>Advertisement with us </div> */}
            {/* <HomeRightCenterAdd /> */}
          </div>
          {/* <div
            className={` ${isSticky ? "sticky-sidebar offer" : ""} ${
              isLast
                ? "animate__animated animate__fadeOut"
                : "animate__animated animate__fadeIn"
            }`}
            style={{
              display: isLast ? "none " : "block",
            }}
          >
            <OffersPreviewRight count={4} active={isTrending} />
          </div> */}
          <div className="home_all-news-mobile">
            {/* <HotNews setMenuName={onChangeMenu} setTagData={handleChangeTag} /> */}
            <CategorySubNews active={isBottom} /> {/*all News */}
          </div>
        </div>

        {/* <div className={`hw__special-news-group group-4`}>
          
        </div> */}

        {/* </div> */}
        {/* </div> */}
      </div>
    </>
  );
};
export default withRouter(Index);
